// extracted by mini-css-extract-plugin
export var active = "CustomBreadCrumb-module--active--49ea4";
export var alt = "CustomBreadCrumb-module--alt--756f0";
export var breadCrumItemContainer = "CustomBreadCrumb-module--breadCrumItemContainer--6ca27";
export var breadcrumb = "CustomBreadCrumb-module--breadcrumb--6c180";
export var breadcrumbItem = "CustomBreadCrumb-module--breadcrumbItem--8f391";
export var counter = "CustomBreadCrumb-module--counter--3286b";
export var crumbLabel = "CustomBreadCrumb-module--crumbLabel--dcedd";
export var customBreadcrumContainer = "CustomBreadCrumb-module--customBreadcrumContainer--67fd0";
export var desktopOnly = "CustomBreadCrumb-module--desktopOnly--f3794";
export var main = "CustomBreadCrumb-module--main--4f2f5";
export var mobileOnly = "CustomBreadCrumb-module--mobileOnly--53c95";
export var postactive = "CustomBreadCrumb-module--postactive--f60ad";
export var textLeft = "CustomBreadCrumb-module--textLeft--b5864";
export var visuallyHidden = "CustomBreadCrumb-module--visuallyHidden--7e556";